<template lang='pug'>
  v-content
    InduksiViewEmail(:dataRowVisitor='dataRowVisitor'  :dataRequestPermit='dataRequestPermit' :token="token")
</template>
<script>
import InduksiViewEmail from "../components/InduksiViewEmail.vue"

import jwt_decode from "jwt-decode";
import axios from 'axios';
import { mapState } from "vuex";
export default {
  name: "PreviewInduction",
  components: {
  InduksiViewEmail
  },
  data() {
    return {
      dataVisitor: {},
      visitorInfo :{},
      ipForm : '',
      dataRowVisitor :{},
      dataRequestPermit :{},
      visitorToken :{},
      destinationPath: '',
      authorized: true,
      token: ""
    };
  },
    computed: {
      ...mapState([
      "API_URL",
      "fetchDataEditRequests",
      "dataEditRequest",
    ]),
  },
  async mounted() {
    const p = this.$route.params;
    const formCode = this.$route.query.formCode;
    const decoded = jwt_decode(p.token);
    this.token = p.token;
    this.dataVisitor = decoded
    console.log(decoded,p)
    this.ipForm = formCode
    this.visitorToken = p 

    const config = {
        method: "get",
        url: `${this.API_URL}/v1/requests/getById/${decoded._id}`,
        headers: {"Authorization": `Bearer ${p.token}`}
    };
    const result = await axios(config);
    this.dataRowVisitor = result?.data[0]?.ipVisitors[0];
    this.dataRequestPermit = result?.data[0]
  },
  watch: {
  },
};
</script>
